import { render } from "./ClientesPorMarca.vue?vue&type=template&id=b82673d2&scoped=true"
import script from "./ClientesPorMarca.vue?vue&type=script&lang=ts"
export * from "./ClientesPorMarca.vue?vue&type=script&lang=ts"

import "./ClientesPorMarca.vue?vue&type=style&index=0&id=b82673d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b82673d2"

export default script